import { useState } from 'react';
import InvoiceServices from '../services/InvoiceServices';
function useCategoryList() {
  const [categoryList, setCategoryList] = useState([]);
  const [categoryLoading, setCategoryLoading] = useState(false);

  const getCategoryList = async () => {

    setCategoryLoading(true);
    try {
      const params = {
        category: 'BILL_PAYMENT_TOOL'
      };
      const result = await InvoiceServices.getCategoryList(params);
      const data = result.result;
      let list = [];
      list = data.map((val) => ({

        label: `${val.categoryelement_name}`,
        value: val.categoryelement_id,
      }));

      setCategoryList(list);
    } catch (e) {
      console.log('e :', e);
    }

    setCategoryLoading(false);

  };
  return { categoryList, getCategoryList, categoryLoading };
}

export { useCategoryList };
